import React from "react"
import { Modal, ModalBody } from "reactstrap"

interface props {
  show: boolean;
  onCloseClick: () => void;
  title : string
  body? : React.ReactNode
}

function ModalWrapper({ show, onCloseClick, title, body }:props){
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} backdrop={'static'}>
      <div className="modal-content">
        <ModalBody className="px-4 pt-5 pb-3">
          <button type="button" onClick={onCloseClick} className="btn-close position-absolute end-0 top-0 m-3"></button>
          <h5 className="mb-3 text-center text-primary">{title}</h5>
          {body}          
        </ModalBody>
      </div>
    </Modal>
  )
}

export default ModalWrapper
